import * as React from 'react';
import onClickOutside from 'react-onclickoutside';

import { Styled } from './styled';

class Menu extends React.Component {
  render() {
    const { children, emergencePlace, width } = this.props;
    return (
      <Styled.Dropdown emergencePlace={emergencePlace} width={width}>
        {children}
      </Styled.Dropdown>
    );
  }
  handleClickOutside = () => this.props.onExit && this.props.onExit();
}

export const SmallMenuList = onClickOutside(Menu);
